import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Menu, X, Phone, Sun, Moon } from "lucide-react";
import { NAV_LINKS, PHONE_DISPLAY, PHONE_TEL, LOGO_EMBLEM } from "@/data/services";

export const Header = ({ theme, onToggleTheme }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const go = (id) => {
    setOpen(false); // BUGFIX: menu always closes on selection
    const target = id === "priser" ? "services" : id;
    const scroll = () => {
      const el = document.getElementById(target);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    if (pathname !== "/") {
      navigate("/");
      setTimeout(scroll, 120);
    } else {
      scroll();
    }
  };

  const ThemeButton = ({ testid }) => (
    <button
      type="button"
      data-testid={testid}
      onClick={onToggleTheme}
      aria-label="Skift tema"
      className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-[color:var(--rs-gold)]/50 text-[color:var(--rs-gold)] transition-colors duration-300 hover:bg-[color:var(--rs-gold)] hover:text-[#0A0A0A]"
    >
      {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );

  return (
    <header className="sticky top-0 z-50 border-b border-[color:var(--rs-border)] bg-[color:var(--rs-header)] backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3 lg:px-8">
        <button type="button" data-testid="logo-home" onClick={() => go("forside")} className="flex items-center gap-3">
          <img src={LOGO_EMBLEM} alt="Royal Solutions" className="h-10 w-auto" />
          <span className="hidden font-heading text-xl tracking-[0.15em] text-[color:var(--rs-text)] sm:block">
            ROYAL <span className="text-[color:var(--rs-gold)]">SOLUTIONS</span>
          </span>
        </button>

        <nav className="hidden items-center gap-8 lg:flex">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-desktop-${l.id}`}
              onClick={() => go(l.id)}
              className="text-xs uppercase tracking-[0.2em] text-[color:var(--rs-muted)] transition-colors duration-300 hover:text-[color:var(--rs-gold)]"
            >
              {l.label}
            </button>
          ))}
          <a
            href={`tel:${PHONE_TEL}`}
            data-testid="header-phone-link"
            className="inline-flex items-center gap-2 rounded-full border border-[color:var(--rs-gold)]/50 px-4 py-2 text-xs tracking-widest text-[color:var(--rs-gold)] transition-colors duration-300 hover:bg-[color:var(--rs-gold)] hover:text-[#0A0A0A]"
          >
            <Phone size={14} /> {PHONE_DISPLAY}
          </a>
          <ThemeButton testid="theme-toggle-desktop" />
        </nav>

        <div className="flex items-center gap-3 lg:hidden">
          <ThemeButton testid="theme-toggle-mobile" />
          <button
            type="button"
            data-testid="hamburger-toggle"
            aria-label="Menu"
            onClick={() => setOpen((v) => !v)}
            className="text-[color:var(--rs-gold)]"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <nav data-testid="mobile-menu" className="border-t border-[color:var(--rs-border)] bg-[color:var(--rs-header)] px-6 py-4 lg:hidden">
          <div className="flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-${l.id}`}
                onClick={() => go(l.id)}
                className="rounded-lg px-2 py-3 text-left text-sm uppercase tracking-[0.2em] text-[color:var(--rs-text)] transition-colors duration-200 hover:text-[color:var(--rs-gold)]"
              >
                {l.label}
              </button>
            ))}
            <a
              href={`tel:${PHONE_TEL}`}
              data-testid="mobile-phone-link"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center gap-2 rounded-full border border-[color:var(--rs-gold)]/50 px-4 py-3 text-sm tracking-widest text-[color:var(--rs-gold)]"
            >
              <Phone size={16} /> {PHONE_DISPLAY}
            </a>
          </div>
        </nav>
      )}
    </header>
  );
};
